module.exports = __webpack_public_path__ + "img/4.d8ce4420.png";